export const linkedInFwdLinkIdMapping = {
  10001: 2299519,
  10002: 2299740,
  10003: 2299326,
  10004: 2299434,
  10005: 2299435,
  10006: 2299654,
  10007: 2299655,
  10008: 2299327,
  10009: 2299538,
  10010: 2299436,
  10011: 2299656,
  10012: 2299657,
  10013: 2299254,
  10014: 2299255,
  10015: 2299741,
  10016: 2299256,
  10017: 2299742,
  10018: 2299438,
  10019: 2299439,
  10020: 2299539,
  10021: 2299540,
  10022: 2299257,
  10023: 2299440,
  10024: 2299743,
  10025: 2299744,
  10026: 2299328,
  10027: 2299258,
  10028: 2299441,
  10029: 2299259,
  10030: 2299745,
  10031: 2299442,
  10032: 2299658,
  10033: 2299659,
  10034: 2299746,
  10035: 2299541,
  10036: 2299443,
  10037: 2299329,
  10038: 2299330,
  10039: 2299444,
  10040: 2299542,
  10041: 2299445,
  10042: 2299261,
  10043: 2299331,
  10044: 2299543,
  10045: 2299332,
  10046: 2299544,
  10047: 2299545,
  10048: 2299747,
  10049: 2299446,
  10050: 2299333,
  10051: 2299334,
  10052: 2299748,
  10053: 2299447,
  10054: 2299335,
  10055: 2299749,
  10056: 2299448,
  10057: 2299449,
  10058: 2299660,
  10059: 2299547,
  10060: 2299548,
  10061: 2299262,
  10062: 2299336,
  10063: 2299549,
};
